<script>
import axios from '@/utils/axios';
import { Modal } from 'bootstrap';
import { useToast } from 'vue-toastification';

export default {
inject: ['setLoading'],  
 props: {
  categories: { type: Array, default: () => [] }
 },
 data() {
  return {
   errors: {}, 
   toast: useToast(),
   id: '',
   knowledge_base_category_id: '',
   question: '',
   answer: '',
   keywords: [],
   keywordInput: '',
   priority: 0,
   is_active: true
  };
 },
 methods: {
  
  knowledgeBase(row = null){
   this.resetForm(); 
   if(row != null){
    this.id = row.id;
    this.knowledge_base_category_id = row.knowledge_base_category_id;
    this.question = row.question;
    this.answer = row.answer;
    this.keywords = row.keywords ? row.keywords.split(',').map(k => k.trim()).filter(Boolean) : [];
    this.priority = row.priority;
    this.is_active = !!row.is_active;
   } 
  },  

  addKeyword(){
   const value = this.keywordInput.trim();
   if(value && !this.keywords.includes(value)){
    this.keywords.push(value);
   }
   this.keywordInput = '';
  },

  removeKeyword(index){
   this.keywords.splice(index, 1);
  },

   async saveKnowledgeBase(){
    this.errors = {};
    this.setLoading(true); 
    try{
     const payload = {
      knowledge_base_category_id: this.knowledge_base_category_id,
      question: this.question,
      answer: this.answer,
      keywords: this.keywords.join(','),
      priority: this.priority,
      is_active: this.is_active
     };
     let response = [];
     if(this.id){
      response = await axios.put(`/knowledge-bases/${this.id}`, payload);
     }else{
      response = await axios.post('/knowledge-bases', payload);
     }
     this.toast.success(response.data.message);
     this.$emit('updated'); 
     this.closeModal('knowledge_base_modal');
     this.resetForm();
    }catch(error){
     if(error.type == 'validation'){
      this.errors = error.errors;
     }else{
      this.toast.error(error.message);
     }
    }finally{
     this.setLoading(false); 
    }
   },

  async deleteKnowledgeBase(){
   this.setLoading(true);
   try{
    const response = await axios.delete(`/knowledge-bases/${this.id}`);
    this.toast.success(response.data.message);
    this.$emit('updated');
    this.closeModal('delete_modal');
   }catch(error){
    this.toast.error(error.message);
   }finally{
    this.setLoading(false);
   }
  }, 

  closeModal(modalId) {
   const modalEl = document.getElementById(modalId);
   const modal = Modal.getInstance(modalEl);
   if (modal) modal.hide();
  },

  resetForm() {
   this.id = null;
   this.knowledge_base_category_id = '';
   this.question = '';
   this.answer = '';
   this.keywords = [];
   this.keywordInput = '';
   this.priority = 0;
   this.is_active = true;
   this.errors = {};
  },

  },
};
</script>

<template>
  <!-- Add -->
 <div class="modal fade" id="knowledge_base_modal">
 <div class="modal-dialog modal-dialog-centered modal-lg w-100">
 <div class="modal-content">
 <div class="modal-header">
  <h4 class="modal-title">{{ id ? 'Edit' : 'Add' }} FAQ</h4>
  <button type="button" class="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
   <i class="ti ti-x"></i>
  </button>
 </div>
 <form @submit.prevent="saveKnowledgeBase">
  <div class="modal-body pb-0">
   <div class="row">
    <div class="col-md-6">
    <div class="mb-3">
     <label class="form-label">Category</label>
     <vue-select
       v-model="knowledge_base_category_id"
       :options="categories"
       label="name"
       :reduce="c => c.id"
       placeholder="Select Category"
     ></vue-select>
     <div v-if="errors.knowledge_base_category_id" class="text-danger small mt-1">{{ errors.knowledge_base_category_id[0] }}</div>
    </div>
    </div>
    <div class="col-md-6">
    <div class="mb-3">
     <label class="form-label">Priority</label>
     <input type="number" class="form-control" v-model="priority" />
     <div v-if="errors.priority" class="text-danger small mt-1">{{ errors.priority[0] }}</div>
    </div>
    </div>
    <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Question</label>
     <input type="text" class="form-control" v-model="question" />
     <div v-if="errors.question" class="text-danger small mt-1">{{ errors.question[0] }}</div>
    </div>
    </div>
    <div class="col-md-12">
    <div class="mb-3">
     <label class="form-label">Answer</label>
     <textarea class="form-control" rows="4" v-model="answer"></textarea>
     <div v-if="errors.answer" class="text-danger small mt-1">{{ errors.answer[0] }}</div>
    </div>
    </div>
    <div class="col-md-8">
    <div class="mb-3">
     <label class="form-label">Keywords</label>
     <div class="kb-tags-input d-flex flex-wrap align-items-center gap-2 form-control" style="min-height: 42px; height: auto; padding: 6px 10px;">
      <span v-for="(kw, index) in keywords" :key="index" class="badge bg-primary-subtle text-primary d-flex align-items-center gap-1" style="font-weight: 500; padding: 6px 10px;">
       {{ kw }}
       <i class="ti ti-x" style="cursor: pointer; font-size: 12px;" @click="removeKeyword(index)"></i>
      </span>
      <input
       type="text"
       v-model="keywordInput"
       @keydown.enter.prevent="addKeyword"
       @keydown.tab.prevent="addKeyword"
       placeholder="Type keyword and press Enter"
       class="border-0 flex-grow-1"
       style="outline: none; min-width: 150px;"
      />
     </div>
     <div v-if="errors.keywords" class="text-danger small mt-1">{{ errors.keywords[0] }}</div>
    </div>
    </div>
    <div class="col-md-4">
    <div class="mb-3">
     <label class="form-label d-block">Status</label>
     <div class="form-check form-switch">
      <input class="form-check-input" type="checkbox" v-model="is_active" id="kb_is_active">
      <label class="form-check-label" for="kb_is_active">{{ is_active ? 'Active' : 'Inactive' }}</label>
     </div>
    </div>
    </div>
    </div>
    <div class="modal-footer">
    <button type="button" class="btn btn-light me-2" data-bs-dismiss="modal"> Cancel </button>
    <button type="submit" class="btn btn-primary">Save</button>
    </div>
  </div>
  </form>
 </div>
</div>
</div>
  <!-- /Add -->

<!-- Delete Modal -->
<div class="modal fade" id="delete_modal">
 <div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
   <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
     <i class="ti ti-trash-x fs-36"></i>
    </span>
     <h4 class="mb-1">Confirm Delete</h4>
     <p class="mb-3"> You want to delete the item, this cant be undone once you delete.</p>
     <div class="d-flex justify-content-center">
     <a href="javascript:void(0);" class="btn btn-light me-3" data-bs-dismiss="modal">Cancel</a>
     <a href="javascript:void(0);" class="btn btn-danger" @click="deleteKnowledgeBase">Yes, Delete</a>
     </div>
   </div>
  </div>
 </div>
</div>
<!-- /Delete Modal -->
</template>